module.exports = __webpack_public_path__ + "static/media/StartupTalky_logo-3.f030dd0c.png";